<template>
    <button @click="manageHamburger" class="navbar-toggler hamburger hamburger--spin hamburger--collapse position-relative d-flex align-items-center text-primary-hover" type="button" aria-expanded="false" aria-label="Toggle navigation">
        <span class="hamburger-box" :class="{'hamburger-box--close' : open}">
            <span class="hamburger-inner"></span>
        </span>
        <span class="ms-25 hamburger-label h7 shop-menu-link">
            <span class="text-smaller-90 text-md-default-size">MENU</span>
        </span>
    </button>
</template>
<script>

export default {
    props: [],
    data: function () {
        return {
            open:false,
            menu_open: false,
        };
    },
    mounted() {

        window.addEventListener('resize', () => {

            document.querySelector('.navbar-collapse').style = "";
            if(this.open){
                this.open = false;
                this.manageHamburger();
            }

        });
    },
    methods: {
        manageHamburger() {
            //let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let tl = gsap.timeline({});
            let hamburger =  document.querySelector('.hamburger');
            let collapse = document.querySelector('.navbar-collapse');
            //let navbar = document.querySelector('nav.navbar');

            //navbar.setAttribute('data-open', this.open);

            if(!this.open) {

                //document.querySelector('body').classList.add('position-fixed');

                /*document.body.style.top = `-${window.scrollY}px`;
                document.body.style.position = 'fixed';*/

                /*document.body.style.top = `-${window.scrollY}px`;
                document.body.style.position = 'fixed';*/


                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':true, 'mobile':(vw <= 767 ? true : false)});
                //turn hamburger into an X
                hamburger.classList.add('is-active');
                if(window.vw > 767) {

                    let elems = document.querySelectorAll('.menu-animate')
                    gsap.fromTo(elems, {autoAlpha: 0, y: 70}, {duration: .65, delay: .2, force3D:true, ease: 'Power1.easeInOut', autoAlpha:1, y: 0, stagger: 0.06,}, "-=0");

                    //collapse opens
                    tl.to(collapse, {duration: .9, delay: 0, top:"0", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                        }
                    });

                }else{

                    let elems = document.querySelectorAll('.menu-animate')
                    gsap.fromTo(elems, {autoAlpha: 0, x: -30}, {duration: .6, delay: .1, force3D:true, ease: 'Power1.easeInOut', autoAlpha:1, x: 0, stagger: 0.05,}, "-=0");

                    //case slides from side
                    //collapse opens
                    tl.to(collapse, {duration: .9, delay: 0, right:"0", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {

                            })
                        }
                    });
                }

            }else{

                /*document.querySelector('body').classList.remove('position-fixed');

                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scroll(0, parseInt(scrollY || '0') * -1);*/

                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':false, 'mobile':(vw <= 767 ? true : false)});
                if(window.vw > 767) {

                    let elems = document.querySelectorAll('.menu-animate');
                    tl.to(elems, {duration: .3, delay: 0, force3D:true, autoAlpha:0, y: -20, stagger: 0,}, "-=0");

                    //slides back to top
                    tl.to(collapse, {duration: .9, delay: .2, top:"-100vh", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                            document.querySelector('.navbar').classList.remove('navbar--open');
                        }
                    },"-=.3");

                    hamburger.classList.remove('is-active');

                }else{

                    let elems = document.querySelectorAll('.menu-animate');
                    tl.to(elems, {duration: .3, delay: 0, force3D:true, ease: 'Power1.easeInOut', autoAlpha:0, x: -20, stagger: 0,}, "-=0");

                    //slides back to left
                    //the language bordered block turns darker instantly
                    tl.to(collapse, {duration: .9, delay: 0, right:"100vw", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                        }
                    },"-=.3");
                    //slides from side
                    tl.call(function() {
                        hamburger.classList.remove('is-active');
                    }, null, "-=.55");
                }
            }
            this.open = !this.open
        }
    }
}
</script>
